/* ===========================================================================
   Editorial Popup — timing, native submit (captcha-safe), localStorage frequency
   =========================================================================== */
(() => {
  'use strict';

  const popup = document.querySelector('[data-ed-popup]');
  if (!popup) return;

  const STORAGE_KEY = 'ed-popup-state';
  const FORM_HASH = '#ed-popup-form';
  const delay = parseInt(popup.dataset.delay, 10) || 0;
  const frequencyDays = parseInt(popup.dataset.frequency, 10) || 14;
  const exitIntent = popup.dataset.exitIntent === 'true';

  // Skip on cart / checkout / account / challenge pages
  const path = window.location.pathname;
  if (/\/(cart|checkout|account|challenge|tools)/.test(path)) return;

  // Check frequency state
  const readState = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  };
  const writeState = (state) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  };
  const now = Date.now();
  const state = readState();

  // Did the visitor just come back from submitting THIS popup's form?
  // Shopify redirects back to the page (also after its anti-spam captcha) with
  // ?customer_posted=true and the form's #ed-popup-form anchor.
  const params = new URLSearchParams(window.location.search);
  const justPosted =
    !!popup.querySelector('[data-ed-popup-posted]') ||
    (window.location.hash === FORM_HASH && params.get('customer_posted') === 'true');

  if (justPosted) {
    state.subscribed = true;
    state.subscribedAt = now;
    writeState(state);
    // Clean the URL so a refresh doesn't re-trigger this
    params.delete('customer_posted');
    const qs = params.toString();
    try {
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    } catch (e) {}
  } else {
    if (state.subscribed) return; // Already subscribed, never show again
    if (state.dismissedAt && now - state.dismissedAt < frequencyDays * 24 * 3600 * 1000) return;
  }

  const openPopup = () => {
    if (popup.__opened) return;
    popup.__opened = true;
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    const firstInput = popup.querySelector('input[type="email"]');
    if (firstInput && !justPosted) setTimeout(() => firstInput.focus(), 500);
  };

  const closePopup = (markDismissed = true) => {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { popup.hidden = true; }, 500);
    if (markDismissed) {
      const s = readState();
      s.dismissedAt = Date.now();
      writeState(s);
    }
  };

  /* --- Triggers --- */
  let delayTimer = justPosted ? null : setTimeout(openPopup, delay * 1000);

  if (exitIntent && window.matchMedia('(min-width: 800px)').matches) {
    document.addEventListener('mouseout', (e) => {
      if (e.clientY <= 0 && !popup.__opened) {
        clearTimeout(delayTimer);
        openPopup();
      }
    });
  }

  /* --- Close handlers --- */
  popup.addEventListener('click', (e) => {
    if (e.target.closest('[data-ed-popup-close]')) {
      e.preventDefault();
      closePopup();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  /* --- Form --- */
  const form = popup.querySelector('form');
  const formState = popup.querySelector('[data-ed-popup-form-state]');
  const successState = popup.querySelector('[data-ed-popup-success-state]');
  const errorEl = popup.querySelector('[data-ed-popup-error]');

  // Back from a successful signup: show the success state (with the discount code)
  if (justPosted) {
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    openPopup();
  }

  if (form) {
    // The form is submitted NATIVELY on purpose. Shopify's spam protection can
    // send the visitor through a captcha page (/challenge) and then return them
    // here; a fetch() cannot complete that flow (it just gets an HTTP 400).
    form.addEventListener('submit', () => {
      popup.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;
    });
  }

  // If the browser restores the page from the back/forward cache, reset the button
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) popup.classList.remove('is-loading');
  });

  /* --- Copy discount code --- */
  const copyBtn = popup.querySelector('[data-ed-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      const code = copyBtn.dataset.edPopupCopy;
      try {
        await navigator.clipboard.writeText(code);
        copyBtn.classList.add('is-copied');
        const note = copyBtn.parentElement.querySelector('.ed-popup__discount-note');
        if (note) {
          const orig = note.textContent;
          note.textContent = '¡Copiado!';
          setTimeout(() => { note.textContent = orig; copyBtn.classList.remove('is-copied'); }, 2000);
        }
      } catch (e) {}
    });
  }
})();